import React from 'react';

import Box, { type BoxProps } from './box';

const Flex = ({ children, className, ...props }: BoxProps) => (
  <Box {...props} className={className} display="flex">
    {children}
  </Box>
);

export default Flex;
